module.exports = __webpack_public_path__ + "img/13.4a386b8a.webp";